module.exports = __webpack_public_path__ + "img/24.779ba5b1.png";